import { Switch, Route, useRouteMatch, Redirect } from 'peach/router'

import Template from './Template'
import TemplateSubject from './TemplateSubject'
import TemplateSubjectChannel from './TemplateSubjectChannel'
import TemplateSubjects from './TemplateSubjects'

const TemplateSubjectRoutes = () => {
  const { url, path } = useRouteMatch()

  const subjectPath = `${path}/:subjectKey`
  const channelPath = `${subjectPath}/:channelKey`
  const templatePath = `${channelPath}/:templateId`

  return (
    <Switch>
      <Route exact path={path}>
        <TemplateSubjects />
      </Route>

      <Route crumb path={subjectPath}>
        <Switch>
          <Route exact path={subjectPath}>
            <TemplateSubject />
          </Route>

          <Route crumb path={channelPath}>
            <Switch>
              <Route exact path={channelPath}>
                <TemplateSubjectChannel />
              </Route>

              <Route crumb path={templatePath}>
                <Template />
              </Route>
            </Switch>
          </Route>
        </Switch>
      </Route>

      <Redirect to={url} />
    </Switch>
  )
}

export default TemplateSubjectRoutes
